var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { forwardRef, useEffect, useRef } from 'react';
import { Label } from '../../../atoms/Label';
import './CheckboxStyles.scss';
/**
 * Checkbox Component
 * @version 1.2.0
 * @since 2026-01-27
 * @updated 2026-03-09 - Added indeterminate prop for ControlGroup Tiered variant
 * @updated 2026-03-26 - Removed unnecessary nesting; label is now optional/conditional
 */
export const Checkbox = forwardRef((_a, ref) => {
    var { id, checked, onChange, onClick, label, description, className = '', indeterminate = false, disabled } = _a, props = __rest(_a, ["id", "checked", "onChange", "onClick", "label", "description", "className", "indeterminate", "disabled"]);
    const internalRef = useRef(null);
    // Merge forwarded ref with internal ref
    const setRefs = React.useCallback((node) => {
        internalRef.current = node;
        if (typeof ref === 'function') {
            ref(node);
        }
        else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = node;
        }
    }, [ref]);
    // Set indeterminate DOM property via JavaScript (not HTML attribute)
    useEffect(() => {
        if (internalRef.current) {
            internalRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    const containerClass = ['qmb-ui-checkbox', disabled ? 'qmb-ui-checkbox--disabled' : '', className]
        .filter(Boolean)
        .join(' ');
    return (React.createElement("div", { className: containerClass },
        React.createElement("input", Object.assign({ ref: setRefs, type: "checkbox", id: id, checked: checked, "aria-checked": indeterminate ? 'mixed' : checked, disabled: disabled, onChange: (e) => {
                e.stopPropagation();
                onChange(e.target.checked);
            }, onClick: (e) => {
                e.stopPropagation();
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            } }, props)),
        label && (React.createElement(Label, { htmlFor: id, className: `qmb-ui-checkbox__label${description ? ' qmb-ui-checkbox__label--bold' : ''}` }, label)),
        description && React.createElement("span", { className: "qmb-ui-checkbox__description" }, description)));
});
Checkbox.displayName = 'Checkbox';
